"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Icons_1 = require("../../DataDisplay/Icons");
var Feedback_1 = require("../../Feedback");
var IconButton_1 = require("../../Input/IconButton");
var InfoModal = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'info' : _b, open = _a.open, onClose = _a.onClose, title = _a.title, content = _a.content;
    var Icon = Icons[type];
    return ((0, jsx_runtime_1.jsx)(Feedback_1.Modal, { open: open, onClose: function () { return onClose(); }, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { id: "modal-inner", sx: {
                width: 280,
                borderRadius: 3,
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'grey.100',
                outline: 'none',
            }, children: [(0, jsx_runtime_1.jsx)(material_1.Stack, { direction: "row-reverse", sx: { pt: 1, px: 1 }, children: (0, jsx_runtime_1.jsx)(IconButton_1.Close, { onClick: onClose, size: "small" }) }), (0, jsx_runtime_1.jsxs)(material_1.Stack, { justifyContent: "center", alignItems: "center", sx: { px: 5 }, children: [(0, jsx_runtime_1.jsx)(Icon, { fontSize: "large", sx: { color: 'text.primary' } }), typeof title === 'string' ? ((0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "h6", sx: { pt: 1 }, children: title })) : (title)] }), (0, jsx_runtime_1.jsx)(material_1.Stack, { sx: { pt: 4, px: 5, pb: 7 }, children: content })] }) }));
};
exports.InfoModal = InfoModal;
var Icons = {
    info: Icons_1.Info,
    help: Icons_1.Help,
};
